import React, {useState} from 'react';
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import OrderSummaryComponent from "../../../pages/checkout/orderSummaryComponent";
import PropTypes from "prop-types";
import CheckoutNavigationSteps from "./checkoutNavigationSteps";
import {convertCartToPurchaseData} from "../../../modules/checkoutHelpers";
import {sendSlackMessage} from "../../../models/notifications";

export default function  PaymentComponent() {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const baseURL = window.location.origin;
        const returnURL = `${baseURL}/status`;
        const response = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: returnURL,
            },
        });

        if (response.error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(response.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
            console.log("Converting the cart data")
            convertCartToPurchaseData()
        }
    };

    return (
        <div className="mx-auto max-w-2xl px-4 pb-24 sm:px-6 lg:max-w-7xl lg:px-8">

            <form onSubmit={handleSubmit}>
                <div className="border-t border-gray-200 m-4">
                    <CheckoutNavigationSteps selectedIndex={0}/>
                </div>
                <div className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                    <div>
                        <div className="border-t border-gray-200 m-4">
                            {/*<h2 className="text-lg font-bold text-gray-900">Submit payment</h2>*/}
                        </div>
                        <PaymentElement options={{
                            layout: 'accordion',
                        }}/>
                        {/* Show error message to customer */}
                    </div>

                    <div>
                        <OrderSummaryComponent hideToggleFrequency={true}
                            ctaString={"Submit"} ctaAction={() => {
                                sendSlackMessage("✅Clicked on the submit button.")
                            handleSubmit()
                        }} onToggleFrequency={() => {
                        }}
                        />

                        {/*{errorMessage && <div>{errorMessage}</div>}*/}
                    </div>
                </div>
            </form>

        </div>
    )
};


PaymentComponent.propTypes = {}